import { useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

const scrollToElement = (id) => {
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: "smooth" });
    return true;
  }
  return false;
};

const pollScroll = (id) => {
  if (scrollToElement(id)) return null;
  let attempts = 0;
  const timer = window.setInterval(() => {
    attempts++;
    if (scrollToElement(id) || attempts >= 30) {
      window.clearInterval(timer);
    }
  }, 100);
  return timer;
};

export default function ScrollToTop() {
  const { pathname, search, hash } = useLocation();
  const navigationType = useNavigationType();
  const previousPage = useRef(null);
  const previousPath = useRef(null);

  useEffect(() => {
    const page = pathname + search;
    // gtag config records the initial load. Track subsequent client-side routes
    // explicitly because React Router does not reload the document.
    if (previousPage.current !== null && previousPage.current !== page) {
      if (
        localStorage.getItem('vt_cookie_consent') === 'accepted' &&
        typeof window.gtag === 'function'
      ) {
        window.gtag('event', 'page_view', {
          page_location: window.location.href,
          page_path: page,
          page_title: document.title,
        });
      }
    }
    previousPage.current = page;
  }, [pathname, search]);

  useEffect(() => {
    const samePath = previousPath.current === pathname;
    previousPath.current = pathname;
    const params = new URLSearchParams(search);
    const openParam = params.get("open");

    if (openParam === "treyjuthraut") {
      console.log("[ScrollToTop] fann ?open=treyjuthraut, byrja poll fyrir spurning-dagsins");
      const timer = pollScroll("spurning-dagsins");
      return () => { if (timer) window.clearInterval(timer); };
    }

    if (hash) {
      let id = hash.slice(1);
      try { id = decodeURIComponent(id); } catch {}
      const timer = pollScroll(id);
      return () => { if (timer) window.clearInterval(timer); };
    }

    if (samePath || navigationType === "POP") {
      console.log("[ScrollToTop] POP navigation, ekki að núllstilla skroll");
      return;
    }
    console.log("[ScrollToTop] núllstilli skroll í topp");
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, search, hash, navigationType]);

  return null;
}